import { Sparkles } from "lucide-react";

interface ModeToggleProps {
  onAIMode: () => void;
}

export function ModeToggle({ onAIMode }: ModeToggleProps) {
  return (
    <div
      className="flex items-center p-1 rounded-full gap-1"
      style={{ background: "#F0EEEB" }}
    >
      <button
        type="button"
        className="px-4 py-1.5 rounded-full text-sm font-semibold transition-all duration-200"
        style={{ background: "#1A1814", color: "white" }}
        disabled
      >
        Clássico
      </button>
      <button
        type="button"
        onClick={onAIMode}
        className="flex items-center gap-1.5 px-4 py-1.5 rounded-full text-sm font-semibold transition-all duration-200 hover:opacity-80"
        style={{ background: "transparent", color: "#78736D" }}
      >
        <Sparkles className="w-3.5 h-3.5" />
        Modo AI
      </button>
    </div>
  );
}
